var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.875,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E39B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5247 18.1334L21.8663 8.8934C21.7617 8.72457 21.6157 8.58525 21.4422 8.48863C21.2686 8.39202 21.0733 8.34131 20.8747 8.34131C20.6761 8.34131 20.4807 8.39202 20.3072 8.48863C20.1336 8.58525 19.9876 8.72457 19.883 8.8934L14.2247 18.1334C13.2348 19.7486 12.7099 21.6057 12.708 23.5001C12.708 25.666 13.5684 27.7432 15.1 29.2748C16.6315 30.8063 18.7087 31.6667 20.8747 31.6667C23.0406 31.6667 25.1178 30.8063 26.6494 29.2748C28.1809 27.7432 29.0413 25.666 29.0413 23.5001C29.0394 21.6057 28.5146 19.7486 27.5247 18.1334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/water_icon.5c7b86b2203cf1203467ac6aad5eeef2.svg";
export { ForwardRef as ReactComponent };